export default __webpack_public_path__ + "static/media/ios-s3_bk.98e3d7f5.webp";